module.exports = __webpack_public_path__ + "static/media/stop.93c0822e.svg";